import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Divider,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useWarbandStore } from '../../stores/warbandStore';
import { createIceSurface, createSteelSurface } from '../../theme/surfaces';
import { GoogleSignInButton } from '../shared/GoogleSignInButton';
import { GameSystemSelector } from '../shared/GameSystemSelector';
import { useGameStore } from '../../stores/gameStore';
import { getGameDefinition } from '../../game/gameDefinitions';

export const LandingPage: React.FC = () => {
  const { openCreateWarbandModal } = useWarbandStore();
  const activeGameSystem = useGameStore((state) => state.activeGameSystem);
  const setActiveGameSystem = useGameStore((state) => state.setActiveGameSystem);
  const game = getGameDefinition(activeGameSystem);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 64px)',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Card sx={{ maxWidth: 400, textAlign: 'center', ...(activeGameSystem === 'frostgrave' ? createIceSurface(123, {icicles: true, card: true}) : createSteelSurface(123)) }} >
          <CardContent sx={{ py: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {game.name}
            </Typography>
            <GameSystemSelector value={activeGameSystem} onChange={setActiveGameSystem} fullWidth />
            <Typography color="textSecondary" sx={{ mb: 3 }}>
              Select a {game.partyName.toLowerCase()} from the menu to get started, or create a new one.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddIcon />}
              onClick={openCreateWarbandModal}
              fullWidth
            >
              Create New {game.partyName}
            </Button>

            <Divider sx={{ my: 3 }} />

            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Sign in to back up and sync your warbands across devices via Google Drive.
            </Typography>
            <GoogleSignInButton />

            <Divider sx={{ my: 3 }} />

            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              THE FINE PRINT: Osprey Games have very kindly allowed us to create this app, but it is <i>not an official product</i>. Please support the creators by purchasing their products.
            </Typography>

          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
